import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  ServicioSolicitudesSuministroService, ParametrosFiltrosSolicitudSuministrosEntity, EstadoRegistroEntity,
  MedicamentosEntity, EntidadEmpresarial, DataSolicitudSuministrosBodyEntity, FiltrosSolicitudesSuministrosEntity
} from '../../../services/servicio-solicitudes-suministro.service';
import { SelectItem } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { FileService } from '../../../services/utils/file.service';
import { saveAs } from 'file-saver';
import { InformacionUsuario } from '../../../services/servicio-solicitudes-suministro.service';

@Component({
  selector: 'app-header-solicitudes-suministros',
  templateUrl: './header-solicitudes-suministros.component.html',
  styleUrls: ['./header-solicitudes-suministros.component.css']
})

export class HeaderSolicitudesSuministrosComponent implements OnInit {
  canDownload: boolean;
  downloading: boolean;
  mensaje: string;
  loading: boolean;
  mensajeError: string;
  tablas: any;

  estadosSuministros: EstadoRegistroEntity[];
  estadosSuministrosItem: SelectItem[] = [];
  estadosSuministrosSelected: SelectItem[] = [];

  medicamentos: MedicamentosEntity[];
  medicamentosItem: SelectItem[] = [];
  medicamentosSelected: SelectItem[] = [];

  @Input() public codigoBaseDatos: string;
  @Input() public objetoParametrosEntity: ParametrosFiltrosSolicitudSuministrosEntity;
  @Input() public objetoFiltrosEntity: FiltrosSolicitudesSuministrosEntity;
  @Input() public objetoDataBody: DataSolicitudSuministrosBodyEntity[];
  @Output() entidadEmpresarial: EventEmitter<EntidadEmpresarial>;
  @Output() informacionUsuario: EventEmitter<InformacionUsuario>;
  @Output() filtrosSeleccionados: EventEmitter<FiltrosSolicitudesSuministrosEntity>;
  @Output() cargandoFiltros: EventEmitter<any>;

  constructor(
    private servicioSolicitudSuministros: ServicioSolicitudesSuministroService,
    private servicioArchivo: FileService,

  ) {
    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
    this.entidadEmpresarial = new EventEmitter();
    this.informacionUsuario = new EventEmitter();
    this.cargandoFiltros = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.getEntidadEmpresarial();
    this.getInformacionUsuario();
  }

  async getEstados() {
    try {
      const response = await this.servicioSolicitudSuministros.getEstados(this.objetoParametrosEntity);
      if (response != null) {
        response.subscribe((data: EstadoRegistroEntity[]) => {
          this.estadosSuministros = data;
          this.loading = false;
          this.estadosSuministrosItem = [];
          this.mensaje = 'Cargando...';
          data.forEach((estadosSuministrosTemporal: EstadoRegistroEntity) => {
            this.estadosSuministrosItem.push({ label: estadosSuministrosTemporal.descripcion, value: estadosSuministrosTemporal.unco });
          });

        }, (err: HttpErrorResponse) => {
          console.log('Error EstadosSuministros', err);
          if (err.status === 500) {
            this.estadosSuministros = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getMedicamentos() {
    try {
      const response = await this.servicioSolicitudSuministros.getMedicamentos(this.objetoParametrosEntity);
      if (response != null) {
        response.subscribe((data: MedicamentosEntity[]) => {
          this.medicamentos = data;
          this.loading = false;
          this.medicamentosItem = [];
          this.mensaje = 'Cargando...';
          data.forEach((medicamentosTemporal: MedicamentosEntity) => {
            this.medicamentosItem.push({ label: medicamentosTemporal.descripcionMedicamentos, value: medicamentosTemporal.uncoCatalogoSuministroMedicamentos });
          });
        }, (err: HttpErrorResponse) => {
          console.log('Error EstadosSuministros', err);
          if (err.status === 500) {
            this.medicamentos = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getEntidadEmpresarial() {

    try {
      const response = await this.servicioSolicitudSuministros.getEntidadEmpresarial(this.objetoParametrosEntity);
      if (response != null) {
        response.subscribe((data: any) => {
          this.loading = false;
          data = data[0];
          const entidad: EntidadEmpresarial = {
            identificacionTributaria: data.identificacionTributaria,
            digitoVerificacion: data.digitoVerificacion,
            descripcion: data.descripcion,
            direccion: data.direccion,
            telefono: data.telefono,
            logoUrl: data.urlLogo,
            codigoPrestador: data.codigoPrestador,
          };
          this.entidadEmpresarial.emit(entidad);
        }, (err: HttpErrorResponse) => {
          console.log('Error entidad Empresarial', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('Error en datos entidad empresarial: ' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getInformacionUsuario() {
    try {
      const response = await this.servicioSolicitudSuministros.getInformacionUsuario(this.objetoParametrosEntity);
      if (response != null) {
        response.subscribe((data: any) => {
          this.loading = false;
          data = data[0];
          const usuario: InformacionUsuario = {
            nombreUsuario: data.nombreUsuario,
            codigoBarrasImprime: data.codigoBarrasImprime,
          };
          this.informacionUsuario.emit(usuario);
        }, (err: HttpErrorResponse) => {
          console.log('Error Info usuario', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('Error en get informacion usuario: ' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  onGenerar() {
    const obj: FiltrosSolicitudesSuministrosEntity = {
      codigoBaseDatos: '',
      estadoSolicitud: '',
      medicamentos: '',
    };
    if (this.estadosSuministrosSelected === null) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar al menos un  <strong>Estado de solicitud</strong>.');
    } else if (this.medicamentosSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar al menos un <strong>Medicamento</strong>.');
    } else {
      obj.estadoSolicitud = String(this.estadosSuministrosSelected);
      obj.medicamentos = String(this.medicamentosSelected);
      this.objetoFiltrosEntity = obj;
      this.canDownload = true;
      this.filtrosSeleccionados.emit(obj);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('suministros-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Solicitud Suministros </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  onDescargarPDF() {

    this.downloading = true;
    document.getElementById('suministros-print').style.width = '125%';
    document.getElementById('suministros-print').style.fontSize = '13px';
    this.tablas = document.getElementsByTagName('table');
    for (const iterator of this.tablas) {
      iterator.style.fontSize = '13px';
    }
    try {
      if (this.validatePDF()) {
        const dataPagina = xepOnline.Formatter.Html('suministros-print', { resolution: '200' });
        const html = `<html><head><meta charset="UTF-8"/></head><body>${dataPagina}</body></html>`;
        const response = this.servicioArchivo.generatePDF(html, 'Solicitud Suministros ', 'solicitudSuministros');
        if (response != null) {
          response.subscribe((data: any) => {
            const filename = data.filename;
            this.servicioArchivo.downloadFile(filename)
              .subscribe((dataTemp) => {
                saveAs(dataTemp, filename);
                this.downloading = false;
              }, err => {
                this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
                console.error('Error download', err);
                this.downloading = false;
              });
          }, (err: HttpErrorResponse) => {
            console.error('Error', err);
            this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
            this.downloading = false;
          });
        } else {
          console.error('Response Null');
        }
        this.downloading = false;
      } else {
        this.downloading = false;
      }

      document.getElementById('suministros-print').style.fontSize = '16px';
      this.tablas = document.getElementsByTagName('table');
      for (const iterator of this.tablas) {
        iterator.style.fontSize = '16px';
      }

      document.getElementById('suministros-print').style.width = '100%';

    } catch (e) {
      this.mostrarMensaje('Error al intentar generar archivo pdf, reporte caso al administrador');
      this.downloading = false;
      console.error(e);
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }

  validatePDF(): boolean {
    if (!this.objetoDataBody || this.objetoDataBody.length < 500) {
      return true;
    } else {
      this.mostrarMensaje('El reporte supera los 500 registros, y no es posible generar el PDF.');
      return false;
    }
  }
}
